import * as React from 'react';
import {useHistory} from 'src/rerouter/index';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {
  SubTitleLarge,
  BodyLarge,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {
  CONSTANTS,
  getTranslatedText,
} from 'src/components/authentication/contants';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';

import ResetImage from 'src/images/reset-confirmation.svg';
import css from './reset-confirmation.css';


const ResetConfirmation = () => {
  const {t} = useLabelTranslation();
  const router = useHistory();

  const goToSignIn = () => {
    router.replace('/signin');
  };

  return (
    <div className={css.resetConfirmationPage}>
      <ResetImage />
      <SubTitleLarge className={css.titleText}>
        {getTranslatedText(t, CONSTANTS.RESET_PASSWORD_CONFIRMATION_TITLE)}
      </SubTitleLarge>
      <BodyLarge className={css.infoText}>
        {getTranslatedText(t, CONSTANTS.RESET_PASSWORD_CONFIRMATION_SUBTEXT)}
      </BodyLarge>
      <Button
        size="medium"
        type="primary"
        onClick={goToSignIn}
        classNames={{wrapper: css.loginBtn}}
      >
        {t('Log_in', 'Log in')}
      </Button>
    </div>
  );
};

export default ResetConfirmation;
